module.exports = __webpack_public_path__ + "img/awesome_ape_256.154c431b.png";